import '../styles/LocationPresence.css';



function LocationPresence() {
    return (
        <section className="presence-section" id="geografisk-narvaro">
            <div className="presence-card">
                <div className="presence-copy">
                    <p className="presence-eyebrow">Närvaro i Sverige</p>
                    <h2>Vi finns överallt</h2>
                    <p className="presence-body">
                    Vi arbetar digitalt och stöttar entreprenörer i hela landet med samma noggrannhet och engagemang, 
                    samtidigt som vårt hjärta och huvudkontor finns på vackra Lidingö i Stockholm. 
                    </p>
                    <div className="presence-cta">
                        <div className="presence-cta-text">
                            <span>Redo att träffas?</span>
                            <p>Boka ett möte med vårt team på Lidingö eller digitalt, vi ser fram emot att träffas!</p>
                        </div>
                        <a className="presence-cta-button" href="/kontakt">Boka ett möte</a>
                    </div>
                </div>
                <div className="presence-map">
                    <iframe
                        title="Stockholm och Lidingö"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        src="https://www.openstreetmap.org/export/embed.html?bbox=18.048%2C59.311%2C18.24%2C59.365&amp;layer=mapnik&amp;marker=59.356%2C18.121"
                    />
                    <div className="presence-map-label presence-map-label--stockholm">Stockholm</div>
                    <div className="presence-map-label presence-map-label--lidingo">Lidingö</div>
                </div>
            </div>
        </section>
    );
}

export default LocationPresence;
